// src/components/Navbar.js
import React from "react";
import { Link } from "react-scroll";
import "./Navbar.css";

export default function Navbar() {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <h1 className="logo">Ankush</h1>
        <ul className="nav-links">
          <li>
            <Link to="home" smooth={true} duration={500} offset={-60}>
              Home
            </Link>
          </li>
          <li>
            <Link to="about" smooth={true} duration={500} offset={-60}>
              About
            </Link>
          </li>
          <li>
            <Link to="projects" smooth={true} duration={500} offset={-60}>
              Projects
            </Link>
          </li>
          <li>
            <Link to="contact" smooth={true} duration={500} offset={-60}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
